/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Orgs_HintInputs */

const cs_portal_orgs_hint = /** @type {(inputs: Portal_Orgs_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Účet je propojen s více kancelářemi. Vyberte, kterou otevřít.`)
};

const en_portal_orgs_hint = /** @type {(inputs: Portal_Orgs_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are linked to more than one office. Pick which one to open.`)
};

/**
* | output |
* | --- |
* | "You are linked to more than one office. Pick which one to open." |
*
* @param {Portal_Orgs_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_orgs_hint = /** @type {((inputs?: Portal_Orgs_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Orgs_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_orgs_hint(inputs)
	return cs_portal_orgs_hint(inputs)
});